const parseLocalDate = (dateString) => {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const isSunday = (dateString) => {
  if (!dateString) return false;
  return parseLocalDate(dateString).getDay() === 0;
};

export const generateTimeSlots = (
  startHour,
  startMinute,
  endHour,
  endMinute
) => {
  const slots = [];
  let hour = startHour;
  let minute = startMinute;

  while (hour < endHour || (hour === endHour && minute <= endMinute)) {
    const value = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
    const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
    const ampm = hour >= 12 ? "PM" : "AM";
    const display = `${displayHour}:${String(minute).padStart(2, "0")} ${ampm}`;
    slots.push({ value, display });

    minute += 15;
    if (minute >= 60) {
      hour += 1;
      minute -= 60;
    }
  }

  return slots;
};

export const getTimeSlotsForDate = (dateString) => {
  if (dateString && isSunday(dateString)) {
    return generateTimeSlots(8, 0, 14, 0);
  }
  return generateTimeSlots(18, 0, 21, 0);
};

export const getTimeSlotValuesForDate = (dateString) => {
  return getTimeSlotsForDate(dateString).map((slot) => slot.value);
};
